import script from "./index.vue?vue&type=script&setup=true&lang=js"
export * from "./index.vue?vue&type=script&setup=true&lang=js"

import "./index.vue?vue&type=style&index=0&id=1e959129&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/悦库.Site-ScoreQuery-Release/apps/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e959129"]])

export default __exports__